const formatString = (dato, len) => {
    dato = (dato)? dato: " ";
    const complemento = ' '.repeat(len);
    let cadena = dato.replace(/\n/g, '');
    cadena = cadena.replace(/\r/g, '');
    cadena = cadena.toString() + complemento;
    cadena = cadena.substr(0, len);
    return cadena;
}

const formatNumber = (dato, len) => {
    dato = (dato)? dato: "0";
    const complemento = '0'.repeat(len);
    let cadena = complemento + dato.toString();
    cadena = cadena.substr(len * (-1));
    return cadena;
}

const processCabeceraTerceros = () => {
    const tmpData = [
        "INDICATIVO",
        "CODIGO",
        "SUCURSAL",
        "NIT",
        "SUCURSAL",
        "NIT DV",
        "NOMBRE",
        "NOMBRE ESTABLEC",
        "PRIMER APELLIDO",
        "SEGUNDO APELLIDO",
        "NOMBRE",
        "TIPO TERC",
        "TIPO IDENTIFACIN",
        "ESTADO",
        "FECHA CREACION",
        "CIUDAD",
        "DIRECCION 1",
        "DIRECCION 2",
        "DIRECCION 3",
        "REGIMEN FISCAL",
        "RESPONSABILIDAD",
        "INFO ADICIONAL(NO TOCAR ESTA CELDA)"
    ]
    return tmpData;
}

const processLineTerceros = (linea) => {
    const infoAdd = (linea.substring(357, 358)==="+") ? linea.substring(357, 1110).replace("+", " ") : linea.substring(357, 1110) ;
    const tmpData = [
        //linea.substring(0, 6) ,//CONSECUTIVO
        linea.substring(6, 8),//CODIGO  0  
        linea.substring(8, 21),//PLTERC-CODIGO 1
        linea.substring(21, 23),//PLTERC-SUCURSAL  2
        linea.substring(39, 54),//PLTERC-NIT   3
        linea.substring(54, 56),//PLTERC-SUCURSAL  4
        linea.substring(56, 57),//PLTERC-NIT-DV    5
        linea.substring(58, 108),//PLTERC-NOMBRE   6
        linea.substring(108, 158),//PLTERC-NOMBRE-ESTABLEC 7
        linea.substring(158, 173),//PLTERC-PRIMER APELLIDO 8
        linea.substring(173, 188),//PLTERC-SEGUNDO APELLIDO    9
        linea.substring(188, 208),//PLTERC-NOMBRE  10
        linea.substring(208, 209),//PLTERC-TIPO-TERC   11
        linea.substring(209, 210), //PLTERC-TIPO-IDENTIFACIN    12
        //linea.substring(210, 220), //PLTERC-TIPO-IDENTIFACIN ---> Espacio vacio 
        linea.substring(220, 221), // ESTADO 13
        linea.substring(221, 229), // FECHA CREACION 15
        linea.substring(229, 237), // CIUDAD 15 
        linea.substring(237, 277), // DIRECCION 1    16
        linea.substring(277, 317),// DIRECCION 2    17
        linea.substring(317, 357), // DIRECCION 3    18
        linea.substring(326, 330),     // "REGIMEN FISCAL",  19
        linea.substring(341, 357),     //"RESPONSABILIDAD", 20    
        infoAdd // INFO ADICIONAL  21


    ];
    return tmpData;
};

const processFormatCadena = (data, pos) => {

    const reg = (data[19] === "") ? "  " : data[19];
    const resp = (data[20] === "") ? "  " : data[20];
    const dir3 = "REGFISCAL " + reg + " RESPOFISCAL " + resp;
    let linea = "";
    if (formatNumber(data[0], 2) === "99") {
        linea = formatNumber((pos), 6)
            + formatNumber(data[0], 2);
    } else {
        linea = formatNumber((pos), 6)
            + formatNumber(data[0], 2)
            + formatString(data[1], 13)
            + formatNumber(data[2], 2)
            + formatString(" ", 16)
            + formatNumber(data[3], 15)
            + formatNumber(data[4], 2)
            + formatNumber(data[5], 1)
            + formatString("", 1)
            + formatString(data[6], 50)
            + formatString(data[7], 50)
            + formatString(data[8], 15)
            + formatString(data[9], 15)
            + formatString(data[10], 20)
            + formatNumber(data[11], 1)
            + formatNumber(data[12], 1)
            + formatString(" ", 10)
            + formatString(data[13], 1)
            + formatString(data[14], 8)
            + formatString(data[15], 8)
            + formatString(data[16], 40)
            + formatString(data[17], 40)
            + formatString(dir3, 40)
            + formatString(data[21], 753)
    }
    linea += "\n";

    return linea;
};

const funciones = {
    processLineTerceros: processLineTerceros,
    processFormatCadena: processFormatCadena,
    processCabeceraTerceros: processCabeceraTerceros
}

export default funciones;